import { Sparkles } from "lucide-react";

/**
 * AiLoader Component
 * A minimal, elegant loader inspired by Google Gemini.
 * Clean typography with a subtle pulsing sparkle and shimmering text.
 */
function AiLoader({
  loading,
  message = "Generating insights...",
  fullPage = false,
}: any) {
  if (!loading) return null;

  return (
    <div
      className={`${
        fullPage
          ? "fixed inset-0 bg-white/60 backdrop-blur-sm z-[9999]"
          : "relative w-full py-3"
      } flex flex-col items-center justify-center transition-all duration-300`}
    >
      <div className="flex items-center gap-3">
        {/* Minimal Pulsing Sparkle */}
        <div className="relative">
          <Sparkles size={20} className="text-blue-600 animate-pulse" />
          <div className="absolute inset-0 bg-blue-400/20 blur-lg rounded-full animate-pulse" />
        </div>

        {/* Shimmering Text */}
        <h3 className="text-lg font-medium tracking-tight overflow-hidden">
          <span className="inline-block bg-gradient-to-r from-blue-600 via-purple-500 to-blue-600 bg-[length:200%_auto] bg-clip-text text-transparent animate-[shimmer_2s_linear_infinite]">
            {message}
          </span>
          <style>{`
            @keyframes shimmer {
              0% { background-position: 200% center; }
              100% { background-position: -200% center; }
            }
          `}</style>
        </h3>
      </div>

      {/* Optional: Very subtle subtext */}
      {!fullPage && (
        <p className="mt-1 text-xs text-gray-400 font-normal opacity-70">
          AI is analyzing your data
        </p>
      )}
    </div>
  );
}

export default AiLoader;
